import type { RouteObject } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import { Toaster } from "react-hot-toast"
import Home from "@/pages/Home"
import EmeraldCalculator from "@/pages/EmeraldCalculator"
import SapphireCalculator from "@/pages/SapphireCalculator"
import AmethystCalculator from "@/pages/AmethystCalculator"
import OpalCalculator from "@/pages/OpalCalculator"
import BirthstoneCalculator from "@/pages/BirthstoneCalculator"

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/emerald-calculator", element: <EmeraldCalculator /> },
  { path: "/sapphire-calculator", element: <SapphireCalculator /> },
  { path: "/amethyst-calculator", element: <AmethystCalculator /> },
  { path: "/opal-calculator", element: <OpalCalculator /> },
  { path: "/birthstone-calculator", element: <BirthstoneCalculator /> },
]

function App() {
  return (
    <>
      {useRoutes(routes)}
      <Toaster position="top-center" />
    </>
  )
}

export default App
